"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
var styles = {
    msFabricScrollDisabled: 'msFabricScrollDisabled_4129cea2',
};
exports.default = styles;
load_themed_styles_1.loadStyles([{ "rawString": ".msFabricScrollDisabled_4129cea2{overflow:hidden!important}" }]);
/* tslint:enable */ 

//# sourceMappingURL=scroll.scss.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/utilities/lib/scroll.scss.js
// module id = 158
// module chunks = 0